import { render, staticRenderFns } from "./MobileRecomment.vue?vue&type=template&id=6f5f78da&scoped=true&"
import script from "./MobileRecomment.vue?vue&type=script&lang=js&"
export * from "./MobileRecomment.vue?vue&type=script&lang=js&"
import style0 from "./MobileRecomment.vue?vue&type=style&index=0&id=6f5f78da&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f5f78da",
  null
  
)

export default component.exports